(function($) {
    $.fn.simpleJekyllSearch = function(options) {
        var settings = $.extend({
            jsonFile        : '/search.json',
            jsonFormat      : 'title,tags,units,person,description,department,author,name,authorname,principalinvestigators,principalinvestigatorsnames,otherinvestigators,otherinvestigatorsnames,url,date,name_department,content',
            templates : { 
                project: {
                    name: 'Projects',
                    template: '<li class="searchresult result_project"><a href="{url}">{title} - {principalinvestigatorsnames}</a></li>'
                },
                person: {
                    name: 'People',
                    template: '<li class="searchresult result_person"><a href="{url}">{name_department}</a></li>'
                },
                post: {
                    name: 'News',
                    template: '<li class="searchresult result_post"><a href="{url}">{title} - {authorname}<span class="entry-date"><time datetime="{date}">{date}</time></span></a></li>'
                }
            },
            typetemplate : '<li class="searchtypeheader result_{searchtype}">{searchtypename}</li>',
            searchResults   : '.search-results',
            searchResultsTitle: '',
            limit           : '10',
            noResults       : '<li class="searchnoresult result_{searchtype}">Oh no! We didn\'t find anything :(</li>'
        }, options);

        var properties = settings.jsonFormat.split(',');

        var jsonData = [],
            origThis = this,
            searchResults = $(settings.searchResults),
            searchtypes = sitesearches,//array defined in head.html, which types to search, search type needs to be declared in settings.templates
            checkclasses =['entry-date'];

        if(!isEmpty(showcaseData) && showcaseDataBuilddate==showcaseDataStoreDate){//the localstorage has the search.json data, and it is fresh
            jsonData = showcaseData;//showcaseData here should be defined, and be the searchindex in search.json
            registerEvent();
        }else if(settings.jsonFile.length && searchResults.length){//search data is either not set or is stale, refresh
            $.ajax({
                type: "GET",
                url: siteurl+baseurl+settings.jsonFile,//use the siteurl and sitebaseurl set in header.html
                dataType: 'json',
                success: function(data, textStatus, jqXHR) {
                    jsonData = data.searchindex;
                    storeshowcase(data);//store the search.json data locally
                    registerEvent();
                },
                error: function(x,y,z) {
                    console.log("***ERROR in simpleJekyllSearch.js***");
                    console.log(x);
                    console.log(y);
                    console.log(z);
                    // x.responseText should have what's wrong
                }
            });
        }

        function registerEvent(){
            origThis.keyup(function(e){
                if($(this).val().length){
                    var searchterm=$(this).val();
                    $.each(searchtypes,function(k,v){
                        writeMatches(performSearch(searchterm,v),v);
                        var ht=$('.searchtypeheader.result_'+v).text();
                        $('.searchtypeheader.result_'+v).text(ht+' ('+String($('.searchresult.result_'+v).length)+')');
                    });
                    if($('.searchresult').length>10){
                        $('.searchtypeheader.hasresults').first().trigger('click');
                    }
                }else{
                    clearSearchResults('all');
                }
            });
        }

        function performSearch(str,t){
            var matches = [];
            $.each(jsonData,function(i,entry){
                for(var i=0;i<properties.length;i++)
                    if(entry[properties[i]] !== undefined && entry[properties[i]].toLowerCase().indexOf(str.toLowerCase()) !== -1 && entry.itemType==t){
                        matches.push(entry);
                        i=properties.length;
                    }
            });
            return matches;
        }
        var matchtext="Matches";
        function writeMatches(m,t) {
            clearSearchResults(t);
            var typeheader=settings.typetemplate;
            var nameregex = new RegExp("\{searchtypename\}", 'g');
            var typeregex = new RegExp("\{searchtype\}", 'g');
            typeheader = typeheader.replace(nameregex, settings.templates[t].name);
            typeheader = typeheader.replace(typeregex, t);
            searchResults.append( $(typeheader) );

            if(m.length) {
                $.each(m,function(i,entry){
                    if(i<settings.limit){
                        var output=settings.templates[t].template;
                        for(var i=0;i<properties.length;i++){
                            var regex = new RegExp("\{" + properties[i] + "\}", 'g');
                            output = output.replace(regex, entry[properties[i]]);
                        }
                        searchResults.append($(output));
                    }
                });
                $('.searchtypeheader.result_'+t).addClass('hasresults');
            }else{
                var noresults = settings.noResults.replace(typeregex, t);
                searchResults.append( $(noresults) );
                $('.searchtypeheader.result_'+t).removeClass('hasresults');
            }
            $('.searchtypeheader.result_'+t).click(function(){
                $('.searchresult,.searchnoresult').hide();
                $('.searchtypeheader').removeClass('viewingresults');
                $('.searchresult.result_'+t+',.searchnoresult.result_'+t).show();
                $(this).addClass('viewingresults');
            });
            $.each(checkclasses,function(k,v){
                $('.'+v).each(function(ki,vi){
                    var thistext=$(this).text();
                    if(thistext.length==0){
                        $(this).remove();
                    }
                });
            });
        }

        function clearSearchResults(t){
            if(t=='all'){
                searchResults.children().remove();
            }else{
                searchResults.children('.result_'+t).remove();
            }
        }
    }
}(jQuery));
